module.exports = __webpack_public_path__ + "static/media/list-solid.8f230ab3.svg";